import { ListItemText, MenuItem } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

export const CustomMenuItem = ({
  children,
  disabled,
  onClick,
  icon,
}: {
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
}) => {
  return (
    <MenuItem onClick={onClick} sx={{ minWidth: '252px' }} disabled={disabled}>
      <ListItemText
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body" color={colors.grey[900]}>
          {children}
        </Typography>
        {icon}
      </ListItemText>
    </MenuItem>
  );
};
